import * as React from "react";
import Cookies from "js-cookie";
import { IconLocale, COOKIES } from "@puregym/ui";
import { cultures } from "./constants";
import { Languages, Language } from "./styles";
import { Switcher } from "./types";

/**
 * Sort language objects array based on culture code.
 * We sort by code to maintain sort order regardless of locale.
 * e.g. Arabic (العربية) appears under 'A' because the code is 'ar'.
 */
const sortLanguages = (a, b) => {
  const codeA = a.cultureCode.toLowerCase();
  const codeB = b.cultureCode.toLowerCase();

  return codeA.localeCompare(codeB);
};

const LanguageSwitcher = ({
  localizedBasePaths,
  defaultLocale,
  locales,
  rootDomain,
  title,
}: Switcher): JSX.Element => {
  const languageLinks = [...cultures]
    .filter(
      (culture) =>
        locales.includes(culture.cultureCode) &&
        culture.cultureCode in localizedBasePaths
    )
    .sort(sortLanguages)
    .map((culture) => {
      const { cultureCode, languageName, rtl } = culture;
      const isActive = process.env.GATSBY_LOCALE === cultureCode;
      const isDefault = defaultLocale === cultureCode;
      const basePath = localizedBasePaths[cultureCode];

      const path = isDefault
        ? `/${basePath}/`
        : `/${cultureCode.toLowerCase()}/${basePath}/`;

      const href = path.replace(/\/{2,}/g, "/");

      return (
        <Language
          as={isActive ? "span" : "a"}
          dir={rtl ? "rtl" : "ltr"}
          href={!isActive ? href : undefined}
          isActive={isActive}
          key={`changeCulture${cultureCode}`}
          onClick={() =>
            Cookies.set(COOKIES.LANGUAGE, cultureCode, {
              domain: rootDomain,
              expires: 365,
            })
          }
        >
          <span>{languageName}</span>
        </Language>
      );
    });

  return (
    <Languages id="language-switcher">
      <IconLocale title={title} />
      {languageLinks}
    </Languages>
  );
};

export default LanguageSwitcher;
